<div class="card no-gutter widget-overview-box widget-overview-box-5 h-100">
	<div class="d-flex">
		<span class="overview-icon">
			<fa-icon [icon]="['far', 'solar-system']"></fa-icon>
		</span>
		<span class="overview-title">
			<div class="d-flex">
				<div>System Status</div>
			</div>
		</span>
	</div>
	<div class="">
		<div *ngIf="venueService.subscriptionVenue.value" style="height: 100px" class="overflow-scroll">
			<div *ngFor="let rec of venueService.subscriptionVenue.value.VenuePos?.devices">
				<div class="p-grid">
					<div class="p-col" style="text-align: left">
						{{ rec.name }}

						<fa-icon class="mx-1" [icon]="['far', 'mobile']" *ngIf="rec.isMobile"></fa-icon>
						<fa-icon class="mx-1" [icon]="['far', 'calendar']" *ngIf="rec.isEvent"></fa-icon>
						<fa-icon class="mx-1" [icon]="['far', 'credit-card']" *ngIf="rec.isCredit"></fa-icon>
						<fa-icon class="mx-1" [icon]="['far', 'envelope']" *ngIf="rec.isEmail"></fa-icon>
					</div>
					<div class="p-col" style="text-align: right">
						{{ app.moment(rec.lastPulse).fromNow() }}
						<span *ngIf="app.moment().diff(app.moment(rec.lastPulse), 'minutes') > 10">
							<fa-icon [icon]="['fas', 'circle']" class="red-icon"></fa-icon>
						</span>
						<span
							*ngIf="app.moment().diff(app.moment(rec.lastPulse), 'minutes') < 10 && app.moment().diff(app.moment(rec.lastPulse), 'minutes') > 5"
						>
							<fa-icon [icon]="['fas', 'circle']" class="yellow-icon"></fa-icon>
						</span>
						<span *ngIf="app.moment().diff(app.moment(rec.lastPulse), 'minutes') <= 5">
							<fa-icon [icon]="['fas', 'circle']" class="green-icon"></fa-icon>
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
